module.exports = __webpack_public_path__ + "assets/TDropPerpDetailed.910789faaa217d13dc7c484e3b568605.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/TDropPerpDetailed.png
// module id = 577
// module chunks = 0